import { getSeed } from '@diritto/common/utils/array';
import { useCallback, useEffect, useState } from 'react';
import { LocalStorage } from 'utils/LocalStorage';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';

const TEN_MINUTE = 10 * 60 * 1000;
const ONE_MINUTE = 60 * 1000;

export const useRandomSeed = (sessionSeed?: number) => {
  const [seed, setSeed] = useState(sessionSeed ?? getSeed());

  const refresh = useCallback(() => {
    const currentTimestamp = Date.now();
    let seedGenerateTimestamp = LocalStorage.getItem(LocalStorageKey.SeedGenerateTimestamp);
    if (seedGenerateTimestamp) {
      seedGenerateTimestamp = currentTimestamp.toString();
      LocalStorage.setItem(LocalStorageKey.SeedGenerateTimestamp, currentTimestamp.toString());
    }

    if (currentTimestamp - Number(seedGenerateTimestamp) > TEN_MINUTE) {
      setSeed(getSeed());
      LocalStorage.setItem(LocalStorageKey.SeedGenerateTimestamp, currentTimestamp.toString());
    }
  }, []);

  useEffect(() => {
    refresh();

    const interval = setInterval(refresh, ONE_MINUTE);
    return () => clearInterval(interval);
  }, [refresh]);

  return seed;
};
